export default __webpack_public_path__ + "static/media/Group 10436.4d5ff508.svg";